const initialState = {
    list: [],
    request: false,
    error: null
};

export default function foo(state = initialState, action) {
    const { type, data } = action;

    switch (type) {
        case 'FETCH_WEATHER':
            return {
                ...state,
                request: true,
                error: false
            };
        case 'FETCH_SLA':
            return {
                ...state,
                request: true,
                error: false
            };
        case 'CANCEL_FETCH_WEATHER':
            return {
                ...state,
                request: false,
            };

        case 'FETCH_SUCCESS_WEATHER':
            return {
                ...data,
                request: false,
                error: false
            };

        case 'FETCH_FAILED_WEATHER':
            // console.log("[Weather](Reducer) FETCH_FAILED_WEATHER", action.data);
            return {
                ...state,
                request: false,
                error: action.data
            };
        case 'THROW_ERROR':
            console.log("[Weather](Reducer) Throw Error", action.data);
            return {
                ...state,
                request: false,
                error: action.data
            };

        case 'CLEAN_WEATHER':
            return initialState;

        default:
            return state;
    }
}